module.exports = __webpack_public_path__ + "img/ico-newspaper-grey.b95ecdb0.svg";